// About-the-Author card shown at the bottom of every article page.
const NAVY = "#1B2F5E";
const GOLD = "#C9A96E";

export default function AuthorSection({ name, bio, avatar }) {
  if (!name && !bio) return null;
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  return (
    <section
      className="mt-12 sm:mt-14"
      style={{ maxWidth: "720px", margin: "3rem auto 0", padding: "0 1.5rem" }}
      data-testid="author-section"
    >
      <div className="text-[11px] sm:text-xs uppercase tracking-[0.22em] font-semibold mb-3" style={{ color: GOLD }}>
        About the Author
      </div>
      <div
        className="rounded-2xl px-5 sm:px-6 py-5 sm:py-6 flex items-start gap-4 sm:gap-5"
        style={{
          background: "#F4F1EA",
          border: `1px solid ${NAVY}12`,
        }}
      >
        <div
          className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center"
          style={{ background: `${GOLD}22`, color: NAVY, fontWeight: 700 }}
          aria-hidden={avatar ? "true" : undefined}
        >
          {avatar ? (
            <img
              src={avatar}
              alt={`${name} avatar`}
              width="48"
              height="48"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
              data-testid="author-avatar"
            />
          ) : (
            <span aria-hidden>{initial}</span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          {name ? (
            <div className="font-semibold text-sm sm:text-base leading-tight" style={{ color: NAVY }} data-testid="author-name">
              {name}
            </div>
          ) : null}
          {bio ? (
            <p className="mt-1.5 text-sm sm:text-[0.95rem] leading-relaxed" style={{ color: "#4A5568" }} data-testid="author-bio">
              {bio}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
